import { useLocation, useNavigate } from 'react-router-dom';
import { useApiRoot } from '../contexts/ApiRootContext';

const inactive =
  'px-4 py-2 text-sm font-medium text-gray-500 hover:text-emerald-600 rounded-lg hover:bg-emerald-50 transition-colors';
const active = 'px-4 py-2 text-sm font-medium text-emerald-700 bg-emerald-50 rounded-lg';

type PrimaryKey = 'dashboard' | 'upload' | 'search' | 'monitoring';

const NAV_ITEMS: { key: PrimaryKey; label: string; path: string; linkRel: string }[] = [
  { key: 'search', label: 'Search', path: '/search', linkRel: 'search' },
  { key: 'upload', label: 'Upload', path: '/upload', linkRel: 'upload' },
  { key: 'dashboard', label: 'Dashboard', path: '/dashboard', linkRel: 'dashboard_metrics' },
  { key: 'monitoring', label: 'Monitoring', path: '/monitoring', linkRel: 'monitoring' },
];

function activeKeyFromPath(pathname: string): PrimaryKey | null {
  if (pathname === '/dashboard') return 'dashboard';
  if (pathname === '/upload') return 'upload';
  if (pathname === '/search' || pathname.startsWith('/search/')) return 'search';
  if (pathname === '/monitoring') return 'monitoring';
  return null;
}

export default function PrimaryNavLinks({
  orientation = 'horizontal',
  onNavigate,
}: {
  orientation?: 'horizontal' | 'vertical';
  onNavigate?: () => void;
}) {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { hasLink } = useApiRoot();
  const current = activeKeyFromPath(pathname);
  const vertical = orientation === 'vertical';

  return (
    <>
      {NAV_ITEMS.filter((nav) => hasLink(nav.linkRel)).map((nav) => {
        const isActive = current === nav.key;
        return (
          <a
            key={nav.key}
            href={nav.path}
            role={vertical ? 'menuitem' : undefined}
            onClick={(e) => {
              if (!e.ctrlKey && !e.metaKey) {
                e.preventDefault();
                onNavigate?.();
                navigate(nav.path);
              }
            }}
            className={`${isActive ? active : inactive}${vertical ? ' block w-full text-left' : ''}`}
          >
            {nav.label}
          </a>
        );
      })}
    </>
  );
}
